import { store, store$ } from '@redux/store';
import { searchParametersActions, isCustomOrBuildOnYourLotSelector } from 'features/searchResultsFacets';
import { distinctUntilChanged, fromEvent, map } from 'rxjs';
import OtherFiltersType from '../enums/otherFiltersType';

const container = document.querySelector('[data-other-filters]');
const otherFilterValue$ = fromEvent(container, 'change');

otherFilterValue$.subscribe((event) => {
  const target = event?.target;
  const value = target?.value;
  switch (value) {
    case OtherFiltersType.HotDeals.toString():
      store.dispatch(searchParametersActions.fetchConsumerPromos(target.checked));
      break;
    case OtherFiltersType.PriceReduction.toString():
      store.dispatch(searchParametersActions.fetchPriceReduction(target.checked));
      break;
    case OtherFiltersType.Reviews.toString():
      store.dispatch(searchParametersActions.fetchBuilderReviews(target.checked));
      break;
    case OtherFiltersType.HomeOwnersAssociationFee.toString():
      store.dispatch(searchParametersActions.fetchHomeOwnersAssociationFee(target.checked));
      break;
    default:
      break;
  }
});

store$
  .pipe(
    map((lastState) => {
      const otherFilters = {
        reviews: lastState.searchParameters?.facts?.builderReviews === true,
        hotDeals: lastState.searchParameters?.facts?.consumerPromos,
        priceReduction: lastState.searchParameters?.facts?.priceReduction,
        homeOwnersAssociationFee: lastState.searchParameters?.facts?.hasHomeOwnersAssociationFee,
      };
      return otherFilters;
    }),
    distinctUntilChanged()
  )
  .subscribe((otherFilters) => {
    const filterNames = Object.keys(otherFilters);
    filterNames.forEach((filter) => {
      const filterCheckbox = container.querySelector(`[value="${filter}"]`);
      filterCheckbox.checked = otherFilters[filter];
    });
  });

// Price reduction and HOA filters don't apply to custom/BOYL listings, so they are disabled.
const filtersDisabledForCustom = [
  OtherFiltersType.PriceReduction.toString(),
  OtherFiltersType.HomeOwnersAssociationFee.toString(),
];

store$
  .pipe(map(isCustomOrBuildOnYourLotSelector), distinctUntilChanged())
  .subscribe((isCustomOrBuildOnYourLot) => {
    filtersDisabledForCustom.forEach((filter) => {
      const filterCheckbox = container.querySelector(`[value="${filter}"]`);
      if (filterCheckbox) {
        filterCheckbox.disabled = isCustomOrBuildOnYourLot;
      }
    });
  });
